import { formatterFactor } from '@/utilities/format';
import type { Peer } from './MultipleVsPeers';

export const getPeersRatioAverage = (
  peers: Peer[],
  selectedCompanySymbol: string | undefined | null
) => {
  const otherPeers = peers.filter(
    (peer) => peer.uniqueSymbol !== selectedCompanySymbol
  );

  const peersToCompare = otherPeers
    .filter((peer) => typeof peer.ratio === 'number' && peer.ratio > 0)
    .map((peer) => peer.ratio);

  const ratioSum = peersToCompare.reduce(
    (ratio, preferredRatio) => ratio + preferredRatio,
    0
  );
  const peersSize = peersToCompare.length;

  const average = peersSize > 0 ? ratioSum / peersSize : null;
  const averageFormatted =
    peersSize && average ? formatterFactor(average) : 'n/a';

  return { average, averageFormatted };
};
